import { ResolveFn } from '@angular/router'

export interface InviteData {
  email?: string
  userId?: string
}

export const registrationResolver: ResolveFn<InviteData> = (route) => {
  const userId = route.queryParams['u']
  const email = route.queryParams['e']
  return {
    email,
    userId,
  }
}
